import React, { useState, useEffect, useContext, useCallback } from "react"
import Context from "../utils/Context"
import ShowMessage from "../components/ShowMessage"
import api from "../api/api"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faThList, faCross, faXmark, faSave } from '@fortawesome/free-solid-svg-icons'

export default function ModalDistribution() {

  const context = useContext(Context)
  const [designations, setDesignations] = useState()
  const [distributions, setDistributions] = useState()
  const [operations, setOperations] = useState()
  const [selectedOperation, setSelectedOperation] = useState('Smart Retail Loja')
  const [usedItems, setUsedItems] = useState([]);

  const [distributionsPositions, setDistributionsPositions] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20])

  useEffect(() => {
    const fetchUsedItems = async () => {
      const result = await api.findUsed({ type: 2 })
      if (result && result.data.length > 0) setUsedItems(result?.data[0]?.positions)
      else setUsedItems([])
    }

    const fetchOperations = async () => {
      api
        .getOperations({})
        .then((res) => {
          if (res.data) {
            console.log("operations", res.data)
            setOperations(res.data)
            res.data && res.data.length > 0 && res.data.map((e) => console.log("operations", e.name))
          }
        })
        .catch((e) => console.log(e))
    }

    fetchUsedItems()
    fetchOperations()

  }, [])

  useEffect(() => {
    //setDistributions(context.distributions)
  }, [distributions])

  const clearBuffer = async () => {

    try {
      await api.deleteUsed(2)

      const fetchUsedItems = async () => {
        const result = await api.findUsed({ type: 2 })
        if (result && result.data.length > 0) setUsedItems(result?.data[0]?.positions)
        else setUsedItems([])
      }

      fetchUsedItems()
    } catch (error) {
      context.actions.setMessage({ message: "Erro a limpar", type: "error" })
    }

    context.actions.setMessage({ message: "Buffer limpo!", type: "success" })


  }


  const handleSelectValuePriority = (event) => {

    let distributionsValues = distributions

    distributionsValues[event.target.id].priority = Number(event.target.value)
    context.actions.setDistributions(distributionsValues)


    setDistributions(distributionsValues)
  }

  const handleSelectValueOperations = (event) => {

    const operationsValues = operations[0]

    const selectedOption = event.target.options[event.target.selectedIndex]
    const selectedId = Number(selectedOption.id)

    operationsValues[selectedId]._id = event.target.value
    context.actions.setOperation(operations.find(op => op._id === event.target.value))
    setSelectedOperation(operations.find(op => op._id === event.target.value))
  }


  const handleSelectValue = (event) => {

    let distributionsValues = distributions

    distributionsValues[event.target.id].position = Number(event.target.value)

    context.actions.setDistributions(distributionsValues)


    setDistributions(distributionsValues)
  }

  const addOperationIdToDistributions = () => {
    if (selectedOperation) {
      const operationId = selectedOperation._id
      const updatedDistributions = distributions.map(distribution => ({
        ...distribution,
        OperationId: operationId
      }))
      setDistributions(updatedDistributions)
    }
  }

  const save = useCallback(async () => {
    let msg = " "
    let typeMsg = "error"

    var respSave
    let saveValidation

    //Verify this condition
    saveValidation = distributions.every((e) => e?.position !== "")

    if (saveValidation) {

      addOperationIdToDistributions()

      try {

        //Check looping necessery
        respSave = await api.saveDistributions(distributions)

        context.actions.setDistributions(distributions)

        msg = "Lista guardada"
        typeMsg = "success"

        context.actions.setMessage({ message: msg, type: typeMsg })

      } catch (error) {
        context.actions.setMessage({ message: "Erro a guardar", type: "error" })
        console.log("Error", error)
      }

    }
  })

  // clear inputs
  const handleClearInputs = () => {

    context.actions.setDistributions([])
    setDistributions([])

  }

  const deleteEntry = (id) => {
    let distributionsValues = distributions

    distributionsValues.splice(id, 1)

    context.actions.setDistributions(distributionsValues)

    setDistributions(distributionsValues)

  }



  const add = () => {

    let addNewDistribution = distributions

    addNewDistribution.push({ priority: distributions.length + 1, missionName: "distributions", owner: context.robotInfo?.owner ? context.robotInfo.owner : "SONAE", robotName: context.robotInfo?.name ? context.robotInfo.name : "1500PT", robotId: context.robotInfo?._id ? context.robotInfo._id : "668569a25067644208b2c3fe", areaId: context.areaId, idOperation: selectedOperation?._id })

    context.actions.setDistributions(addNewDistribution)

    console.log("-- ", distributions, " +++ ", context.distributions)

  }

  const renderCells = (items) => {

    return (
      <>
        <div className='label' style={{ marginBottom: '20px' }}>Buffer:</div>
        <p></p>
        <div className='columns is-multiline'>


          {items && items.length > 0 && items.map((item) => {
            return <div className='column is-one-fifth' style={{ marginLeft: '20px', marginBottom: '10px', border: 'solid 1px black', borderRadius: '10px', textAlign: 'center' }}>
              {item}
            </div>
          })}
        </div>

      </>

    )
  };



  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>

        <header className="modal-card-head">
          <p className="modal-card-title">Transport Request</p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => context.actions.setModalState({ ...context.modalState, distribution: false })}
          ></button>
        </header>

        <section className="modal-card-body">

          <div className="field mb-5">
            <label className="label">Transport Request</label>

            {/*<div className="columns is-mobile">
              <div className="column is-half">
                <label className="label">
                  <u>
                    Operação
                  </u>
                </label>
              </div>
            </div>
            <div>
              <p className="control is-expanded">
                <select
                  style={{ minHeight: "2.5rem" }}
                  defaultValue={selectedOperation ? selectedOperation._id : "Pick Operation..."}
                  onChange={handleSelectValueOperations}
                >
                  <option value="">Pick Operation...</option>
                  {operations && operations[0].length > 0 && operations[0].map((m, i) =>
                    <option key={i} id={i} value={m?._id}>
                      {m?.name}
                    </option>
                  )}
                </select>
              </p>
            </div>*/}

            <div className="columns is-multiline is-mobile">
              <div className="column is-one-fifth">
                <label className="label">
                  <u>
                    Pick
                  </u>
                </label>
              </div>

              <div className="column">
                <label className="label">
                  <u>
                    Drop
                  </u>
                </label>
              </div>

              {distributions && distributions.length > 0 && distributions.map((e, idx) =>
                <div className="column is-full">
                  <div className="field has-addons">
                    <div className="control column is-one-fifth">
                      <div className="select">
                        <select
                          id={idx}
                          onChange={handleSelectValuePriority}
                          style={{
                            paddingLeft: '13px',
                            paddingRight: '28px'
                          }} >

                          {distributionsPositions.map((d) => {
                            if (distributions.some(dist => dist.priority === d)) {
                              return <option disabled selected={d === e.priority ? true : false}>{d}</option>
                            } else {
                              return <option selected={d === e.priority ? true : false}>{d}</option>
                            }
                          })}
                        </select>
                      </div>
                      <div className="icon is-small is-left">
                        <i className="fas fa-globe"></i>
                      </div>
                    </div>

                    <p className="control is-expanded column">
                      <select
                        id={idx}
                        //selected={distributions[idx].position}
                        style={{ minHeight: "2.5rem" }}
                        defaultValue={"Choose destination..."}
                        onChange={handleSelectValue}
                        value={distributions[idx].position}
                      >
                        <option value="">Choose destination...</option>
                        {designations && designations.length > 0 && designations.map((m, i) =>
                          <option key={i} value={m?.position}>
                            {m?.description}
                          </option>
                        )}
                      </select>
                    </p>

                    <p className="control is-vcentered">
                      <button
                        onClick={() => deleteEntry(idx)}
                        className="button is-danger"
                      >
                        <FontAwesomeIcon icon={faXmark} className="is-small" />
                      </button>
                    </p>
                  </div>
                </div>
              )}
            </div>

          </div>



          <div className="control mb-5">
            <button className="button is-light" onClick={add}>
              Add
            </button>
          </div>

          {usedItems ? renderCells(usedItems) : null}

          <ShowMessage />

          <div className="control">
            <button className="button is-success is-pull-left mb-2" onClick={save} style={{ marginRight: "1rem" }}>
              <FontAwesomeIcon icon={faSave} className="is-small mr-1" />
              Save changes
            </button>

            <button className="button is-pull-left is-danger mb-2" style={{ marginRight: "1rem" }} onClick={handleClearInputs}>
              <FontAwesomeIcon icon={faTrash} className="is-small mr-1" />
              Reset all
            </button>

            <button className="button is-outlined is-pull-right is-link mr-2 mb-2" style={{ marginRight: "1rem" }} onClick={() => clearBuffer()}>
              <FontAwesomeIcon icon={faThList} className="is-small mr-1" />
              Reset occupation
            </button>

            <button className="button is-success is-pull-right" style={{ marginRight: "1rem" }} onClick={() => context.actions.setModalState({ ...context.modalState, distribution: false })}>
              Close
            </button>
          </div>

        </section>
      </div>
    </div>
  )


}